import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Card from '../../components/Card'; 

function CountryPage() {
  const [country, setCountry] = useState(null); 
  const [relatedObjects, setRelatedObjects] = useState([]);
  const [loadingRelatedObjects, setLoadingRelatedObjects] = useState(true);
  const { plcid } = useParams(); 
  const uniqueObjectIds = new Set(); 

const fetchCountry = async () => {
  try {
    const response = await fetch(`/api/place/country/${plcid}`);
    const jsonData = await response.json();
    setCountry(jsonData[0]); 
    const objectIds = jsonData[0].obj_id;

    for (const id of objectIds) {
      console.log(`Fetching related object with ID: ${id}`); 
      await fetchRelatedObject(id); 
    }
  } catch (err) {
    console.error(err.message);
  }
};

  const fetchRelatedObject = async (id) => {
    try {
      const response = await fetch(`/api/item/${id}`);
      const jsonData = await response.json();

      const newObjects = Array.isArray(jsonData) ? jsonData : [jsonData];

      newObjects.forEach(newObj => {
        if (!uniqueObjectIds.has(newObj.obj_id)) {
          uniqueObjectIds.add(newObj.obj_id); 
          setRelatedObjects(prevObjects => [...prevObjects, newObj]); 
        }
      });

      setLoadingRelatedObjects(false);

      console.log("Updated relatedObjects:", relatedObjects);
    } catch (err) {
      console.error("Error fetching related objects:", err);
      setLoadingRelatedObjects(false); 
    }
  };

  useEffect(() => {
    fetchCountry();
  }, [plcid]);

  if (!country) {
    return <p>Loading...</p>; 
  }
  
  return (
    <Fragment>
<div className="detailpage">
    <h1>Country: {country.cont_name}</h1>
    
    <div className="detailpage_desc">  
        <div className="place-wrapper">
      {country.city_names && country.city_names.length > 0 ? (
    <>
     <div className="detailpg_data_row">
        <h4 className="detailpg_title">Child City:</h4>
        <div className="place-list">
          {country.city_names.map((city, index) => (
            <React.Fragment key={index}>
              <div className="place-item">
                <Link to={`../place/city/${country.city_id[index]}`}>
                  <span><h4>{city}</h4></span>
                </Link>
              </div>
              {index < country.city_names.length - 1 && (
                <span className="separator">,</span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  ) : (
    <div className="na">No Data</div>
  )}
</div>

</div>

<h4 id="rel_title">Related Objects</h4>
      <div className="related-objects">
      <div className="container">
      <div className="wrapper">
      <div className="csrow">
              {relatedObjects.map(object => {
                const media = object.media ? 'thumb_' + object.media.split(',')[0] : '';  
                
                return (
                  <Card
                    key={object.obj_id}
                    id={object.obj_id}
                    ref_id={object.ref_id}
                    title={object.title}
                    media={media}  
                    media_type={object.med_name}
                    project={object.prj_name}
                    record_date={object.record_date ? new Date(object.record_date).toLocaleDateString() : 'No date available'}
                  />
                );
              })}
            </div>            
        </div>
        </div>
        </div>
        </div>

    </Fragment>
  );
  
}

export default CountryPage;
